import { arrayRemove, arrayUnion, doc, updateDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

// Los usuarios bloqueados se guardan en roles/{uid}.bloqueados
export const bloquearUsuario = (miUid, otroUid) =>
  updateDoc(doc(db, "roles", miUid), { bloqueados: arrayUnion(otroUid) });

export const desbloquearUsuario = (miUid, otroUid) =>
  updateDoc(doc(db, "roles", miUid), { bloqueados: arrayRemove(otroUid) });
